import React from 'react';
import avo from 'analytics/avo';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import PropTypes from 'prop-types';
import ProductCardGridUI from '../ProductCardGridUI';
import ProductCardStatic from '../ProductCardStatic';

const CartRecentlyViewedProducts = ({ productIds, onClick }) => {
  const { products } = useStaticProductCardData({
    productIds,
  });

  return (
    <ProductCardGridUI columnsOnDesktop="2" limitWidth={false}>
      {products.map(product => (
        <ProductCardStatic
          key={product.slug}
          analyticsComponentName={avo.Component.RECENTLY_VIEWED_CAROUSEL}
          layout="minimal"
          {...product}
          onClick={onClick}
        />
      ))}
    </ProductCardGridUI>
  );
};

CartRecentlyViewedProducts.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func,
};

export default CartRecentlyViewedProducts;
